import { Address } from "@opendaw/lib-box";
import { UUID } from "@opendaw/lib-std";
export var EngineAddresses;
(function (EngineAddresses) {
    EngineAddresses.PEAKS = Address.compose(UUID.Lowest).append(0);
    EngineAddresses.SPECTRUM = Address.compose(UUID.Lowest).append(1);
    EngineAddresses.WAVEFORM = Address.compose(UUID.Lowest).append(2);
})(EngineAddresses || (EngineAddresses = {}));
